<template>
    <div style="margin-top: -10px; ">
        <div class="row">
            <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                <span class="row-table-font-margins" style="font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center">{{buildingName}} / Additional Expenses</span>
                </div>
            </div>
        </div>
        
            
                <div class="table-responsive">
                <table class="table table-condensed">
                    <thead>
                        <th style="width:20%">No</th>
                        <th style="width:20%">Property</th>
                        <th style="width:20%">Amount</th>
                        <th style="width:20%">Paid</th>
                        <th style="width:20%">Remaining</th>
                    </thead>
                    
                    <tbody>
                        <tr v-for="expense, key in additionalExpenses">
                            <td>{{ ++key }}</td>
                            <td>{{ expense.property.propertyName}}</td>
                            <td>{{ $filters.currency(expense.expenseAmount, '€') }}</td>
                            <td>{{ $filters.currency(expense.paidAmount, '€') }}</td>
                            <td>{{ $filters.currency(expense.remainingAmount, '€') }}</td>
                        </tr>
                    </tbody>
                </table>    
                </div>            
            <a @click="$router.go(-1)" class="btn btn-cancel" style="display: block; margin-left: auto; margin-right: 0; margin-top: 15px">Back</a>
            
        
	</div>
</template>
<script>
import { mapState } from "vuex";
import {format} from 'date-fns'
export default {
    data: function(){
        return{
            additionalExpenses :[],
            buildingId:0,
          //  buildingName:'',
            expenseId:0
        }
    },
    mounted()
    {
        this.buildingId = this.$route.params.buildingId;
       // this.buildingName = this.$route.params.buildingName;
        this.expenseId = this.$route.params.expenseId;
        this.fetchStatement();
    },
    computed: {
    ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
},
    methods: {
         fetchStatement: function(){
                    this.mute = true;
                     var request = '/additionalexpenses/expense?id='+this.expenseId;
                    this.$http.get(request, {
                        id : this.expenseId
                    }).then(({data}) => {
                                this.mute = false;
                            this.additionalExpenses = data;
                });
            },
            
      customFormatter(date) {
                        
                            return format(date, 'dd/MM/yyyy');
                    },
    }
}
</script>